module.exports = __webpack_public_path__ + "media/images/group-42b8f577a144aec5679d4a473ce408b1.svg";